export interface TrendingData {
  name: string
  imageUrl: string
  relativePath: string
}

export const transformToTrending = (data: any[] | undefined, schemeType: "home_and_electronics" | "cycle_to_work"): TrendingData[] => {
  if (!data) return []

  return data.map((item) => {
    const fullPath = item.link || item.roundel?.link
    const relativePath = fullPath.split(`/${schemeType}/`)[1] || ""

    return {
      name: item.label || item.name,
      imageUrl: item.imageUrl || item.roundel?.imageUrl,
      relativePath
    }
  })
}
